export default __webpack_public_path__ + "images/56884473bf6b57a1b39f53502775d5c7-pain.png";